export const calculateItemGstAmount= (item)=>{
        const taxPercentage = parseFloat(item?.tax?.percentage) || 0;
        const qty = parseInt(item?.qty)
        const itemAmount = parseFloat(item?.prc * qty) || 0;
        if (taxPercentage > 0) {
            const gstAmount = (itemAmount * taxPercentage) / 100;
            return gstAmount;
        }
        return 0;
}